import React from 'react';
import { CloudRain, Thermometer, CalendarRange } from 'lucide-react';
import { formatStatNumber } from '../../utils/tripsCheckClaimsWeatherPivot';
import './weatherDetails.css';

const StatCard = ({ tone, icon: Icon, label, value, unit }) => (
    <article className={`wd-stat wd-stat--${tone}`} aria-label={`${label}: ${value}${unit ? ` ${unit}` : ''}`}>
        <div className="wd-stat__top">
            <div className="wd-stat__label">{label}</div>
            <div className="wd-stat__icon" aria-hidden="true">
                <Icon size={16} strokeWidth={2.25} />
            </div>
        </div>
        <div className="wd-stat__value">
            {value}
            {unit ? <span className="wd-stat__unit">{unit}</span> : null}
        </div>
    </article>
);

/**
 * Rangée de cartes statistiques météo.
 */
const WeatherStatCards = ({ stats }) => {
    if (!stats) return null;

    return (
        <section className="wd-stats" aria-label="Statistiques météo">
            <StatCard
                tone="rain"
                icon={CloudRain}
                label="Total Rainfall"
                value={formatStatNumber(stats.totalRainfall)}
                unit="mm"
            />
            <StatCard
                tone="rain"
                icon={CloudRain}
                label="Maximum Rainfall"
                value={formatStatNumber(stats.maxRainfall)}
                unit="mm"
            />
            <StatCard
                tone="temp"
                icon={Thermometer}
                label="Average Temperature"
                value={formatStatNumber(stats.avgTemperature)}
                unit="°C"
            />
            <StatCard
                tone="temp"
                icon={Thermometer}
                label="Minimum Temperature"
                value={formatStatNumber(stats.minTemperature)}
                unit="°C"
            />
            <StatCard
                tone="temp"
                icon={Thermometer}
                label="Maximum Temperature"
                value={formatStatNumber(stats.maxTemperature)}
                unit="°C"
            />
            <StatCard
                tone="period"
                icon={CalendarRange}
                label="Observation Period"
                value={stats.observationPeriod || '—'}
            />
        </section>
    );
};

export default WeatherStatCards;
